var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutreProf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 99,
    viewBox: "0 0 84 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 84,
    height: 82,
    transform: "translate(-12 -12.096)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_654",
    x: 10.061,
    y: 12.096,
    width: 32.123,
    height: 43.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d0f95"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_655",
    x: 22.772,
    y: 20.57,
    width: 37.772,
    height: 48.772,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d0f95"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_656",
    x: 41.132,
    y: 12.096,
    width: 32.123,
    height: 43.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d0f95"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_657",
    x: 3,
    y: 27.278,
    width: 38.055,
    height: 56.187,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d0f95"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_658",
    x: 42.262,
    y: 27.278,
    width: 38.055,
    height: 56.187,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d0f95"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_659",
    x: 31.246,
    y: 44.579,
    width: 20.825,
    height: 48.32,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d0f95"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_660",
    x: 31.246,
    y: 44.579,
    width: 20.825,
    height: 48.32,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d0f95"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_661",
    x: 15.711,
    y: 41.274,
    width: 33.535,
    height: 57.726,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d0f95"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_662",
    x: 34.07,
    y: 41.274,
    width: 33.535,
    height: 57.726,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d0f95"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_585",
    "data-name": "Groupe 585",
    transform: "translate(-570 -573.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_584",
    "data-name": "Groupe 584",
    transform: "translate(582 586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_583",
    "data-name": "Groupe 583",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -12.1)",
    filter: "url(#Trac\\xE9_654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_654-2",
    "data-name": "Trac\\xE9 654",
    d: "M636.122,593.061a7.062,7.062,0,1,0-7.062,7.061,6.977,6.977,0,0,0,4.138-1.412,12.694,12.694,0,0,1,2.556-3.531,6.632,6.632,0,0,0,.367-2.118Zm0,0",
    transform: "translate(-602.94 -573.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -12.1)",
    filter: "url(#Trac\\xE9_655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_655-2",
    "data-name": "Trac\\xE9 655",
    d: "M713.772,643.886A9.886,9.886,0,1,1,703.886,634a9.886,9.886,0,0,1,9.886,9.886Zm0,0",
    transform: "translate(-662.23 -613.43)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -12.1)",
    filter: "url(#Trac\\xE9_656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_656-2",
    "data-name": "Trac\\xE9 656",
    d: "M812.123,593.062a7.061,7.061,0,1,0-14.123,0,6.634,6.634,0,0,0,.367,2.175,12.7,12.7,0,0,1,2.557,3.474,6.977,6.977,0,0,0,4.138,1.412,7.062,7.062,0,0,0,7.061-7.062Zm0,0",
    transform: "translate(-747.87 -573.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -12.1)",
    filter: "url(#Trac\\xE9_657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_657-2",
    "data-name": "Trac\\xE9 657",
    d: "M598.947,675.178a11.755,11.755,0,0,1,.155-1.878,10.019,10.019,0,0,1-2.98.466A9.887,9.887,0,0,1,590.473,672l-4.8,1.765A5.648,5.648,0,0,0,582,679.09v20.1h9.886V694.06a8.475,8.475,0,0,1,4.42-7.429l5.749-3.149a12.709,12.709,0,0,1-3.107-8.3Zm0,0",
    transform: "translate(-570 -644.72)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -12.1)",
    filter: "url(#Trac\\xE9_658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_658-2",
    "data-name": "Trac\\xE9 658",
    d: "M820.781,673.765l-4.8-1.765a9.887,9.887,0,0,1-5.649,1.765,10.019,10.019,0,0,1-2.98-.466,11.741,11.741,0,0,1,.155,1.878,12.709,12.709,0,0,1-3.107,8.3l5.749,3.149a8.474,8.474,0,0,1,4.42,7.429v5.126h9.886v-20.1a5.648,5.648,0,0,0-3.672-5.324Zm0,0",
    transform: "translate(-753.14 -644.72)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 573.9)",
    filter: "url(#Trac\\xE9_659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_659-2",
    "data-name": "Trac\\xE9 659",
    d: "M744.825,771.412v11.976l-1.412,5.932L742,783.389V771.412a1.412,1.412,0,0,1,2.825,0Zm0,0",
    transform: "translate(-701.75 -725.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 573.9)",
    filter: "url(#Trac\\xE9_660)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_660-2",
    "data-name": "Trac\\xE9 660",
    d: "M744.825,771.412v11.976l-1.412,5.932L742,783.389V771.412a1.412,1.412,0,0,1,2.825,0Zm0,0",
    transform: "translate(-701.75 -725.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 573.9)",
    filter: "url(#Trac\\xE9_661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_661-2",
    "data-name": "Trac\\xE9 661",
    d: "M656.938,754.388A5.65,5.65,0,0,0,654,759.345v20.662h15.535l-6.878-28.726Zm0,0",
    transform: "translate(-629.29 -710.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 573.9)",
    filter: "url(#Trac\\xE9_662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_662-2",
    "data-name": "Trac\\xE9 662",
    d: "M770.6,754.388l-5.719-3.107L758,780.007h15.535V759.345a5.65,5.65,0,0,0-2.938-4.958Zm0,0",
    transform: "translate(-714.93 -710.01)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutreProf);
export default __webpack_public_path__ + "static/media/autre-prof.c8983b9fc4abe7d7c28e2924d8da72f4.svg";
export { ForwardRef as ReactComponent };